import { render, staticRenderFns } from "./selectGroup.vue?vue&type=template&id=0b501b17&scoped=true"
import script from "./selectGroup.vue?vue&type=script&lang=js"
export * from "./selectGroup.vue?vue&type=script&lang=js"
import style0 from "./selectGroup.vue?vue&type=style&index=0&id=0b501b17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b501b17",
  null
  
)

export default component.exports